/* eslint-disable no-constant-condition */
import {ChessPiece} from "./chessPiece";

export class JumperPiece extends ChessPiece {

    positionsUnderAttack(board) {
        const result = [];
        this.getDirections().forEach(direction => {
            let pos = [this.posX, this.posY];
            while (true) {
                pos = [pos[0] + direction[0], pos[1] + direction[1]];
                if (pos[0] < 0 || pos[0] >= board.scaleX || pos[1] < 0 || pos[1] >= board.scaleY) {
                    break;
                }
                result.push(pos);
                const posPiece = board.getPiece(pos[0], pos[1]);
                if (posPiece) {
                    break;
                }
            }
        });
        return result;
    }

    getDirections() {
        return [];
    }

    availablePositions(board) {
        let result = this.positionsUnderAttack(board);

        result = result.filter(pos => {
            const piece = board.getPiece(pos[0], pos[1]);
            return !piece || piece.player !== this.player;
        });

        result = result.filter(pos => {
           return !this.isCheckAfterMove(board, pos)
        });

        return result;
    }
}